<template>
    <a :href="link" @click.prevent="destroy" class="btn btn-danger btn-icon btn-sm " data-original-title="" title="Delete" type="button">
        <i aria-hidden="true" class="fa fa-trash"></i>
    </a>
</template>

<script>
export default {
    name: "LinkDestroyComponent",
    props: {
        link: {
            type: String,
            required: true
        },
        lineId: {
            type: String,
            required: false
        }
    },
    methods: {
        destroy() {

            let lineId = this.lineId;
            let link = this.link;

            if (confirm('Confirm removal of this record?')) {

                axios.delete(link)
                    .then(function (response) {

                        if (lineId) {
                            showMessage('s', 'Successfully removed');
                            $('#' + lineId).remove();
                        } else {

                            document.location.reload(true);
                        }

                    })
                    .catch(function (error) {
                        showMessage('w', 'Unable to remove');
                        console.error(error);
                    });
            }
        }
    }
}
</script>

<style scoped>

</style>
